import React, { useCallback, useMemo } from 'react';
import { Cancel, Delete as Trash } from '@material-ui/icons';
import { Box, IconButton } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useForm } from 'react-final-form';
import _ from 'lodash';

import QCXButton from '../../../shared-components/button/QCXButton';
import { selectIsLimparCamposActive } from '../../../features/limpar-campos-state/limparCamposSlice';

import { selectMode } from '../../../features/declaracao-importacao/declaracaoImportacaoSelectors';

import { isConsultMode } from '../../../utils/store/store-utils';
import QCXConfirmDialog from '../../../shared-components/dialog/QCXConfirmDialog';
import useOperationMiddleware from '../../../utils/hooks/operation/middleware/useOperationMiddleware';

export default function InputWithCleanButton({ children, style = {} }) {
  const mode = useSelector(selectMode);
  const isConsult = useMemo(() => isConsultMode(mode), [mode]);

  const isLimparCamposActive = useSelector(selectIsLimparCamposActive);

  const name = children?.props?.name?.replaceAll('.', '-') ?? '';
  const label = children?.props?.label;

  const form = useForm();
  const { values } = form.getState();

  const isLimpar = values?.ignorableFields?.limparCampos?.[name] || false;

  const limparCampoToggle = async () => {
    if (!values?.ignorableFields?.limparCampos) {
      form.change('ignorableFields.limparCampos', {});
    }

    const valorAtual = values?.ignorableFields?.limparCampos?.[name] || false;

    form.change(`ignorableFields.limparCampos.${name}`, !valorAtual);
  };

  const [handleLimparOperation, operationOfLimpar] = useOperationMiddleware(limparCampoToggle, []);

  const handleLimparOperationMiddleware = useCallback(
    (data) => {
      const configureOperation = () => ({
        options: {
          title: 'Deseja limpar o campo?',
          message: `Ao confirmar a operação, será repassado vazio para o campo: ${label}`,
        },
      });

      handleLimparOperation(configureOperation, data);
    },
    [handleLimparOperation]
  );

  const handleLimpar = () => {
    const valorAtual = values?.ignorableFields?.limparCampos?.[name] || false;

    if (valorAtual === true) {
      limparCampoToggle();
      return;
    }

    handleLimparOperationMiddleware();
  };

  return (
    <Box display="flex" flexDirection="row" alignItems="center" style={{ gap: 12, ...style }}>
      <Box width="100%">{children}</Box>

      {!isConsult && isLimparCamposActive && (
        <QCXButton
          variant="outlined"
          onClick={handleLimpar}
          disabled={false}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexShrink: 0,
            borderColor: isLimpar ? 'red' : undefined,
            padding: 4,
            width: 20,
            color: isLimpar ? 'red' : undefined,
          }}
        >
          <Trash />
        </QCXButton>
      )}

      <QCXConfirmDialog
        key="confirm-dialog-remove-adicao"
        id="confirm-dialog-remove-adicao"
        open={operationOfLimpar?.active}
        title={operationOfLimpar?.title}
        content={operationOfLimpar?.message}
        endContent={operationOfLimpar?.endMessage}
        onConfirm={operationOfLimpar.confirm}
        onClose={operationOfLimpar?.reset}
      />
    </Box>
  );
}
